import React from 'react';
import './services.css';
import { Helmet } from "react-helmet";

import whatsapp from '../../Assets/whatsapp.png';
import call from '../../Assets/call.png';
import BackDimpleDermalPiercingImage from '../../Assets/Piercing Services/back dimple dermal piercing.png';
import Footer from '../contactus/contactus';

const handleWhatsAppClick = (message) => {
  const url = `https://wa.me/971567257579?text=${encodeURIComponent(message)}`;
  window.open(url, "_blank");
};

function BackDimpleDermalPiercing() {
  return (
    <div>
      <div className="earlobe-container">
        <Helmet>
          <title>Back Dimple Dermal Piercing UAE | 800 AED</title>
        </Helmet>

        <div className="floating-buttons">
          <div
            className='whatsapp-button'
            onClick={() => handleWhatsAppClick("I am interested in Back Dimple Dermal Piercing")}
          >
            <img src={whatsapp} alt="WhatsApp" />
          </div>

          <a href="tel:+971567257579" className="call-button">
            <img src={call} alt="Call" />
          </a>
        </div>

        <h1 className="earlobe-title">
          Back Dimple Dermal Piercing 800 AED
        </h1>

        <div className="earlobe-image-wrapper">
          <img src={BackDimpleDermalPiercingImage} alt="Back Dimple Dermal Piercing" />
        </div>

        <div className="earlobe-content">
          <h3>Back Dimple Dermal Piercing</h3>

          <p>
            Enhance your body aesthetics with our professional back dimple dermal piercing services in the UAE, available at a premium price of 800 AED. Back dimple dermal piercing is a striking and elegant body modification placed on the natural indentations of the lower back, commonly known as back dimples. This unique and visually appealing piercing highlights your natural curves, creating a sophisticated and eye-catching look that exudes confidence and style. Often adorned with sparkling dermal tops or subtle metallic designs, back dimple piercings offer a perfect blend of glamour and individuality, making them a popular choice for those who want to elevate their body art.
          </p>

          <p>
            At our piercing studio, safety, hygiene, and precision are our top priorities. Our certified professionals use sterile, single-use, high-quality equipment to perform each back dimple dermal piercing with exceptional care and accuracy. We strictly follow professional hygiene protocols to maintain a clean and sanitized environment, minimizing the risk of infection and ensuring a safe and smooth experience. Dermal piercings require specialized techniques, and our experienced specialists are highly trained to ensure proper placement, depth, and symmetry, especially for paired back dimple piercings, to achieve a perfectly balanced and aesthetically pleasing result.
          </p>

          <p>
            Back dimple dermal piercing is ideal for individuals who want a bold yet elegant body modification that enhances their natural body shape. Its placement on the lower back creates a stunning visual effect, especially when styled with complementary outfits. This piercing can be worn as a pair for symmetry or as a single piece for a more minimal look, depending on your personal style. Our specialists take the time to understand your preferences and guide you in selecting the best jewelry design and placement to suit your body and desired aesthetic.
          </p>

          <p>
            The procedure is typically quick and efficient, making it convenient for clients with busy schedules. Our team uses advanced techniques designed to reduce discomfort and support effective healing, ensuring that you can enjoy your new piercing with confidence. We also provide high-quality, hypoallergenic dermal jewelry that is safe for sensitive skin, helping to prevent irritation and ensuring a smooth healing process.
          </p>

          <p>
            Our clean, welcoming, and professional environment ensures that every client feels comfortable and confident throughout their visit. We understand that dermal piercings, especially in sensitive areas, can feel intimidating, and our friendly and experienced staff is always available to answer your questions and provide reassurance. From consultation to completion, we focus on delivering a smooth and positive experience tailored to your needs.
          </p>

          <p>
            Aftercare is especially important for back dimple dermal piercings due to their placement and exposure to clothing and movement. We provide detailed instructions to help you maintain proper care during the healing period, including cleaning routines, recommended products, and precautions to avoid irritation, pressure, or displacement. Following proper aftercare is essential for maintaining the longevity and appearance of your piercing.
          </p>

          <p>
            Our back dimple dermal piercing services in the UAE combine premium quality with transparent pricing, ensuring you receive exceptional value without hidden costs. Booking your appointment is quick and convenient, allowing you to choose a time that fits your schedule. We aim to provide minimal waiting time and a seamless experience from start to finish.
          </p>

          <p>
            Choose our trusted back dimple dermal piercing services in the UAE for a safe, hygienic, and professional experience. With skilled specialists, precise techniques, and a strong commitment to customer satisfaction, we help you achieve a stunning and confident look effortlessly. Book your back dimple dermal piercing appointment today and enhance your natural curves with expert care and style.
          </p>

          <button
            className="book-btn"
            onClick={() => handleWhatsAppClick("I want to book Back Dimple Dermal Piercing")}
          >
            Book Now
          </button>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default BackDimpleDermalPiercing;